import { render } from "./HeaderMenu.vue?vue&type=template&id=0d4d0d36&scoped=true"
import script from "./HeaderMenu.vue?vue&type=script&lang=js"
export * from "./HeaderMenu.vue?vue&type=script&lang=js"

import "./HeaderMenu.vue?vue&type=style&index=0&id=0d4d0d36&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-0d4d0d36"

export default script